var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"allBox"},[(_vm.headerShow)?_c('div',{staticClass:"headerBox"},[_vm._t("header",function(){return [_c('Navbar',{attrs:{"title":_vm.title,"topBj":_vm.topBj,"topColor":_vm.topColor,"leftShow":_vm.leftShow,"backUrl":_vm.backUrl}})]})],2):_vm._e(),_c('div',{staticClass:"contentBox",style:({
      backgroundColor: _vm.contentBj,
      top: _vm.headerShow ? '1.2rem' : '0',
      bottom: _vm.footerShow ? '1.6rem' : '0'
    })},[_vm._t("default")],2),(_vm.footerShow)?_c('div',{staticClass:"footerBox"},[_vm._t("footer")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }